import { module } from 'angular';
import templateBuilderSelectDisplay from './builder/display.html';
import templateBuilderSelectData from './builder/data.html';
import templateBuilderSelectValidate from './builder/validate.html';

export default module('app').run(/* @ngInject */ (
	/** @type {import('angular').ITemplateCacheService} */ $templateCache,
) => {
	$templateCache.put('kform/components/select/display.html', templateBuilderSelectDisplay);
	$templateCache.put('kform/components/select/data.html', templateBuilderSelectData);
	$templateCache.put('kform/components/select/validate.html', templateBuilderSelectValidate);
});
